declare global {
  interface Window {
    __AUTOCLIPPER_APP_HANDOFF_SEARCH__?: string;
  }
}

/** The HTML bootstrap captures this before analytics; the fallback covers SPA navigation. */
export function consumeAppHandoffParams(fallbackSearch: string): URLSearchParams {
  const search = window.__AUTOCLIPPER_APP_HANDOFF_SEARCH__ ?? fallbackSearch;
  delete window.__AUTOCLIPPER_APP_HANDOFF_SEARCH__;
  let referrer = document.querySelector<HTMLMetaElement>('meta[name="referrer"]');
  if (!referrer) {
    referrer = document.createElement('meta');
    referrer.name = 'referrer';
    document.head.appendChild(referrer);
  }
  referrer.content = 'no-referrer';
  window.history.replaceState(window.history.state, document.title, '/app-handoff');
  return new URLSearchParams(search);
}

/** Reset by setting content: removing the meta tag does not reset document policy. */
export function restoreAppReferrerPolicy(): void {
  const referrer = document.querySelector<HTMLMetaElement>('meta[name="referrer"]');
  if (referrer) referrer.content = 'strict-origin-when-cross-origin';
}
